import {Grid} from '@mui/material';
import {AppControlledCheckbox} from 'components/form';
import React from 'react';
import {FieldsRendererProps} from './FieldsRenderer';

interface RenderCheckboxProps extends FieldsRendererProps {
    gridSize?: number;
}
export const RenderCheckbox: React.FC<RenderCheckboxProps> = ({field, control, baseFieldName, indexKey, gridSize}) => {
    return (
        <>
            <Grid item md={gridSize} xs={12}>
                <AppControlledCheckbox
                    label={field.title}
                    name={`${baseFieldName}.booleanValue`}
                    control={control}
                    labelPosition="end"
                    required={field.isRequired}
                />
            </Grid>
        </>
    );
};

export default RenderCheckbox;
